import { Component, OnInit, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ResourceModel } from "@app/models/rest/resource";
import { ChildEntityModel } from "@app/view/shared/child-entity-manager/child-entity-model";
import { ResourceRule } from "@app/models/rest/resource-rule";
import { ChildEntityManagerComponent } from "../../../../shared/child-entity-manager/child-entity-manager.component";
import { DialogHeaderComponent } from "@app/view/shared/dialog-header/dialog-header.component";

@Component({
  selector: "app-excluded-properties-dialog",
  templateUrl: "./excluded-properties-dialog.component.html",
  styleUrls: ["./excluded-properties-dialog.component.scss"],
  imports: [DialogHeaderComponent, ChildEntityManagerComponent]
})
export class ExcludedPropertiesDialogComponent implements OnInit {
  dialogRef =
    inject<MatDialogRef<ExcludedPropertiesDialogComponent>>(MatDialogRef);
  data = inject<{
    resource: ResourceModel;
    childEntityModel: ChildEntityModel<ResourceRule, ResourceModel>;
  }>(MAT_DIALOG_DATA);

  resource: ResourceModel;
  childEntityModel: ChildEntityModel<ResourceRule, ResourceModel>;

  ngOnInit(): void {
    this.resource = this.data.resource;
    this.childEntityModel = this.data.childEntityModel;
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onEntityChange(event: any): void {
    // Optional: handle any changes if needed
  }
}
